import { Component, OnInit, AfterViewInit, Input, Output, EventEmitter, ComponentFactoryResolver, ViewContainerRef, Renderer2, Type as AngularCoreType, ViewEncapsulation, ViewChild, ElementRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

import { FormBuilder, FormGroup, FormControl, Validators, ValidatorFn } from '@angular/forms'; // Used for Reactive Forms
import { ControlType, ValidationInfo, ValidationMessageInfo, FormFieldBaseComponent } from '../form-field-base/form-field-base.component';
//import { TextFormFieldBaseComponent } from '../form-field-base/text-form-field-base.component';
import { FormField } from '../../../models/form-builder/form-field.model';
import { FormInstanceElement } from '../../../models/form-builder/form-instance-element.model';
import { FormFieldPropertyEnum } from '../../../models/form-builder/form-field-property-enum.model';
//import { InputFormFieldBaseComponent } from '../input-form-field-base/input-form-field-base.component';
import { TextInputFormFieldBaseComponent } from '../input-form-field-base/text-input-form-field-base.component';
import { FormFieldProcessingPhaseEnum } from '../../../enums/form-field-processing-phase.enum';
import { IGridRow } from '../../../interfaces/grid-row.interface';
import { FormFieldOnInitPropertyEnum } from '../../../models/form-builder/form-field-on-init-output-property.enum';

@Component({
    selector: 'app-telerik-html-editor',
    templateUrl: './telerik-html-editor.component.html',
    styleUrls: ['./telerik-html-editor.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: TelerikHtmlEditorComponent,
            multi: true
        }
    ],
    standalone: false
})
export class TelerikHtmlEditorComponent extends FormFieldBaseComponent implements OnInit {
    // Properties.
    @Output() onInit = new EventEmitter();

    private readonly formFieldProperties: string[] =
        [
            FormFieldPropertyEnum.NAME,
            FormFieldPropertyEnum.FIELD_GROUP,
            FormFieldPropertyEnum.REQUIRED,
            FormFieldPropertyEnum.DISPLAY_NAME,
            FormFieldPropertyEnum.HELP_TEXT,
            FormFieldPropertyEnum.TOOL_TIP,
            FormFieldPropertyEnum.READ_ONLY,
            FormFieldPropertyEnum.INSTRUCTIONS_TEXT,
            FormFieldPropertyEnum.IMAGE_MANAGEMENT_BUTTONS
        ];

    private htmlValue: string = '';

    // Constructor.
    public constructor(rendererParam: Renderer2) {
        super();
    }

    // Life cycle methods.
    public ngOnInit(): void {
        // Emit my propertties.
        let hshOnInitProperties = this.getProperties();
        this.onInit.emit(hshOnInitProperties);
    }

    // Implement abstract methods.
    public getProperties(): any {
        let hshOnInitProperties = {
            component: this,
            formField: this.FormField,
            properties: this.formFieldProperties
        };

        return hshOnInitProperties;
    }

    public getFormFieldClass(): AngularCoreType<any> {
        return TelerikHtmlEditorComponent;
    }

    // Define methods called by my HTML code.
    public get HtmlValue(): string {
        return this.FormInstanceElement != null ? this.FormInstanceElement.textValue : '';
    }
    public set HtmlValue(value: string) {
        //this.htmlValue = value;
        if (this.FormInstanceElement != null)
            this.FormInstanceElement.textValue = value;
    }

    // Handle FormFieldBaseComponent callbacks.
    protected writeValueTriggered(): void {
        if ((this.Mode === 'preview') || (this.Mode === 'instance')) {
            if (this.ControlType === ControlType.REACTIVE_FORMS) {
                // Note:  this method is presently a NOOP by design.
            } // if (this.controlType === ControlType.REACTIVE_FORMS)
        } // if ((this.Mode === 'preview') || (this.Mode === 'instance'))

        return;
    }

}
